import { render, staticRenderFns } from "./infoOpinionBoard.vue?vue&type=template&id=2d199086"
import script from "./infoOpinionBoard.vue?vue&type=script&lang=js"
export * from "./infoOpinionBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d199086')) {
      api.createRecord('2d199086', component.options)
    } else {
      api.reload('2d199086', component.options)
    }
    module.hot.accept("./infoOpinionBoard.vue?vue&type=template&id=2d199086", function () {
      api.rerender('2d199086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/iob/infoOpinionBoard.vue"
export default component.exports